import React from 'react'
import { Menu, X } from 'lucide-react'
import styles from './MobileMenuButton.module.scss'

interface MobileMenuButtonProps {
  isOpen: boolean
  onToggle: () => void
  label: string
}

export const MobileMenuButton: React.FC<MobileMenuButtonProps> = ({ isOpen, onToggle, label }) => (
  <button
    type="button"
    onClick={onToggle}
    className={styles.button}
    aria-label={label}
    aria-expanded={isOpen}
  >
    {isOpen ? <X size={20} /> : <Menu size={20} />}
  </button>
)
